import { Component, inject } from "@angular/core";
import { RichTextContainerComponent } from "@dcc/shared/rich-text-output-ui";
import { VdsDialogContentComponent, VdsDialogHeaderComponent } from "@dcc/vestas-design-system/angular/components/dialog";
import { SpinnerComponent } from "@dcc/vestas-design-system/angular/components/spinner";
import { TermsClient } from "@dcc/vestas-online/data-access";
import { TranslocoDirective } from "@jsverse/transloco";
import { rxResource } from "@angular/core/rxjs-interop";

const TERMS_KEY = "PLATFORM";

@Component({
    selector: "vo-shell-legal-notice",
    templateUrl: "./legal-notice.component.html",
    imports: [TranslocoDirective, RichTextContainerComponent, SpinnerComponent, VdsDialogHeaderComponent, VdsDialogContentComponent]
})
export class LegalNoticeDialogComponent {
    private termsClient = inject(TermsClient);

    protected readonly termsResource = rxResource({
        stream: () => this.termsClient.getTermById(TERMS_KEY)
    });
}
